const { reduce, } = require('lodash');

const ProductBundleCalculator = {
  originalPrice(productBundle) {
    return reduce(productBundle.bundled_products, function (sum, bundledProduct) { return sum + parseFloat(bundledProduct.listing.original_price.amount); }, 0);
  },

  discountedPrice(productBundle) {
    return reduce(productBundle.bundled_products, function (sum, bundledProduct) { return sum + parseFloat(bundledProduct.listing.price.amount); }, 0);
  },

  bundledProductsCount(productBundle) {
    return productBundle.bundled_products.length;
  },

  totalPrice(productBundle) {
    const amount = parseFloat(productBundle.main_listing.price.amount) + this.discountedPrice(productBundle);
    return { amount: amount, symbol: productBundle.main_listing.price.symbol };
  },
};

module.exports = ProductBundleCalculator;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/product_bundle_calculator.js